import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  children,
  disabled,
  startIcon,
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={isLoading || disabled}
      startIcon={
        isLoading ? <CircularProgress size={20} color="inherit" /> : startIcon
      }
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
